module.exports = __webpack_public_path__ + "img/emailh.c2b0a661.png";